import { render, staticRenderFns } from "./OperationSupply.vue?vue&type=template&id=a6ff0df8&scoped=true"
import script from "./OperationSupply.vue?vue&type=script&lang=ts"
export * from "./OperationSupply.vue?vue&type=script&lang=ts"
import style0 from "./OperationSupply.vue?vue&type=style&index=0&id=a6ff0df8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ff0df8",
  null
  
)

export default component.exports